import { render, staticRenderFns } from "./resumen-compra.vue?vue&type=template&id=885a9ba6&"
import script from "./resumen-compra.vue?vue&type=script&lang=js&"
export * from "./resumen-compra.vue?vue&type=script&lang=js&"
import style0 from "./resumen-compra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports